import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Master Satuan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Master Satuan',
        href: '/adm/logistic/satuan',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'code_satuan',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'satuan',
        label: 'Satuan',
        sortable: true,
      },
      {
        key: 'remark_satuan',
        label: 'Remark',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      satuan: '',
      remark_satuan: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeSatuan(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchSatuan(context, params = null) {
    let result = await ApiGetRequest(`logistic/satuan`, params);
    return !result.error ? result.data.object : [];
  },

  async getListSatuan({ commit, state }) {
    commit('changeSatuan', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`logistic/satuan`, params);
    commit('changeSatuan', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailSatuan({ commit, state }, payload = null) {
    commit('changeSatuan', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/satuan/${payload.id}`);
    commit('changeSatuan', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createSatuan({ commit, state, dispatch }) {
    commit('changeSatuan', {
      loading: true,
    });

    let result = await ApiPostRequest(`logistic/satuan`, state.data.form);
    commit('changeSatuan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateSatuan({ commit, state, dispatch }, payload = null) {
    commit('changeSatuan', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `logistic/satuan/${payload.id}`,
      state.data.form
    );

    commit('changeSatuan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteSatuan({ commit, dispatch }, payload = null) {
    commit('changeSatuan', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`logistic/satuan/${payload.id}`);
    commit('changeSatuan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
